import React from "react";
import MonadModal from "ui/build/components/Modal/MonadModal";
import Para from "ui/build/components/Para/Para";

export default function Prompt({ open, dialogData, options }) {
  const onSubmit = (date) => {
    options.onSubmit?.(dialogData);
  };

  return (
    <div>
      <MonadModal
        open={open}
        variant="regular-modal"
        onSubmit={onSubmit}
        onCancel={options.onCancel}
        submitText={options.submitText}
        cancelText={options.cancelText}
        heading={options.heading}
        body={<Para className="ml-3">{options.contentText}</Para>}
        footer={true}
      />
    </div>
  );
}
